import React, { useState, useEffect } from "react";
import DSPPanel from "./DSPPanel/DSPPanel";
import classes from "./DSP.module.css";
import CsoundObj from "@kunstmusik/csound";
import Modal from "../../components/Modal/Modal";
// @ts-ignore
import P5Wrapper from "react-p5-wrapper";
import sketch from "../../sketches/DSP/DSP";
import RegularButton from "../../components/Inputs/Button/RegularButton/RegularButton";

type Props = {};

const DSP: React.FC<Props> = (props) => {
    const [csound, setCsound] = useState<CsoundObj | null>(null);
    const [started, setStarted] = useState(false);

    useEffect(() => {
        let componentIsMounted = true;
        if (csound === null) {
            CsoundObj.initialize(new AudioContext({ sampleRate: 48000, latencyHint: "playback" })).then(
                () => {
                    const cs = new CsoundObj();
                    if (componentIsMounted) {
                        setCsound(cs);
                    }
                }
            );
        }
        return () => {
            componentIsMounted = false;
        };
    }, [csound]);

    const theSketch = <P5Wrapper sketch={sketch} />;

    return (
        <div className={classes.DSP}>
            {csound === null ? (
                <Modal extraClasses={classes.DSPModals}>
                    <div style={{ textAlign: "center" }}>Loading Csound Web Assembly Engine...</div>
                    <div className={classes.Sketch}>{theSketch}</div>
                </Modal>
            ) : started ? (
                <DSPPanel csound={csound} />
            ) : (
                <Modal extraClasses={classes.DSPModals}>
                    {/* <div style={{ textAlign: "center" }}>
                        You will need an updated browser to continue, preferably firefox for optimal
                        performance.
                    </div> */}
                    {theSketch}
                    <RegularButton click={() => setStarted(true)} extraStyles={{ marginBottom: "16px" }}>
                        Play
                    </RegularButton>
                </Modal>
            )}
        </div>
    );
};

export default DSP;
